module.exports = __webpack_public_path__ + "img/hospital_placeholder.77922105.png";